/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * User preferences and state for guided tours.
 */
export interface GuidedTour {
  /**
   * Whether the guided tour feature is enabled for the user.
   */
  enabled: boolean;
  /**
   * Dictionary tracking seen tours (e.g., {'tour_name': true}).
   */
  seenTours: { [key: string]: boolean };
  /**
   * Flag indicating if at least one tour has been shown.
   */
  oneTourShownOnce: boolean;
  /**
   * Flag indicating if the initial tour modal has been opened.
   */
  modalOpenedOnce: boolean;
}
